import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  comments: "/comment",
};

export const fetchComments = createAsyncThunk(
  "comments/fetchComments",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.comments, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createComment = createAsyncThunk(
  "comments/createComment",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.comments, data);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const updateComment = createAsyncThunk(
  "comments/updateComment",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.comments}/${data.slug}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const deleteComment = createAsyncThunk(
  "comments/deleteComment",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.comments}/${slug}`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
